/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const submitCampaignForReviewDataSchema = z.object({
	paymentMethods: z.array(
		z.object({
			type: z.union([z.literal('wallet'), z.literal('invoice'), z.literal('stripe')]),
			amount: z.number().nullable().optional(),
			paymentIntentId: z.string().nullable().optional(),
		}),
	),
	profileId: z.string().uuid().nullable().optional(),
	inventoryItems: z.array(z.object({ id: z.string().uuid(), quantity: z.number() })).optional().default([]),
})

export type SubmitCampaignForReviewDataSchema = z.infer<typeof submitCampaignForReviewDataSchema>
